import { computed, inject, Injectable } from '@angular/core';
import { HomeState } from './home.state';
import { NmWebService } from '../../../services';
import { ENmWebSectionTypes, ENmWebsTypes } from '../../../shared/constants/nm-webs.enums';
import { catchError, filter, map, switchMap, take } from 'rxjs/operators';
import { INmWeb, NmWebSection } from '../../../shared/models/nm-webs.interfaces';
import { of } from 'rxjs';
import { parseCmsSectionToFeaturedLinks } from '../utils/sections.util';

@Injectable()
export class CmsFacade {
  private readonly api = inject(NmWebService);
  private readonly state = inject(HomeState);

  readonly featuredLinksSection = this.state.featuredLinksSection;
  readonly featuredLinksTitle = this.state.featuredLinksTitle;
  readonly featuredLinksSubtitle = this.state.featuredLinksSubtitle;

  readonly featuredLinksCategories = computed(() => {
    const section = this.featuredLinksSection();

    return (
      section?.nmWebChildSections
        ?.filter((child) => child.nmGenericType.name === ENmWebSectionTypes.SECTION_LINK_LIST)
        .map((child) => parseCmsSectionToFeaturedLinks(child)) ?? []
    );
  });

  fetchHomeSections(): void {
    if (this.state.webSections().length > 0) return;

    this.api
      .getByName(ENmWebsTypes.HOME, true)
      .pipe(
        map(([first]) => first),
        filter((web): web is INmWeb => !!web),
        switchMap((web) => this.api.getSections(web.webId, true)),
        take(1),
        catchError(() => of([] as NmWebSection[]))
      )
      .subscribe((sections) => {
        this.state.setWebSections(sections);
      });
  }
}
